import React from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { useEffect } from 'sb-hooks'
import { FormattedMessage } from 'sb-react-intl'

import { Button, buttonMessages } from 'components/_new/controls'

import Title from '../Title/Title'

import messages from './messages'
import s from './UpgradeSuccess.scss'


const UpgradeSuccess = ({ onClose }) => {
  useEffect(() => () => {
    actions.models.upgradeSubscriptionFlow.setCurrStep(constants.upgradeSubscriptionFlowSteps.selectPlan)
    actions.models.upgradeSubscriptionFlow.setActiveMonthIndex(0)
  })

  return (
    <div className={s.upgradeSuccess}>
      <Title message={messages.title} />
      <FormattedMessage {...messages.text} />
      {
        typeof onClose === 'function' && (
          <div className={s.action}>
            <Button
              title={buttonMessages.close}
              color="brand"
              size="md"
              fullWidth
              dataTestId={constants.testIds.modal.dialogModal.button}
              onClick={onClose}
            />
          </div>
        )
      }
    </div>
  )
}

UpgradeSuccess.propTypes = {
  onClose: PropTypes.func,
}


export default UpgradeSuccess
